(function ($) {
	var $select = $('.js-listing-filter-select');

	function init() {
		var parameterKey = $select.data('parameter-key');
		$select.on('change', function () {
			window.location.href = updateQueryStringParameter(parameterKey, this.options[this.selectedIndex].value);
		});
	}

	function updateQueryStringParameter(parameter, value) {
		var queries = window.location.href.indexOf('?') === -1 ? '' : window.location.href.split('?')[1];
		var splittedQueries = queries.split('&');

		for (var i = 0; i < splittedQueries.length; i++) {
			// Update value for selected parameter
			if (splittedQueries[i].indexOf(parameter + '=') > -1) {
				splittedQueries[i] = splittedQueries[i].substr(0, splittedQueries[i].indexOf('=') + 1) + value;
			}
			// Remove parameter without value
			if (splittedQueries[i].indexOf('=') === splittedQueries[i].length - 1) {
				var index = splittedQueries[i].indexOf(parameter);
				splittedQueries[i] = splittedQueries[i].substring(0, index - 1);
			}
		}

		var joinedQueries = splittedQueries.join('&');

		// If parameter didn't exist in previous url, add it
		if (joinedQueries.indexOf(parameter + '=') === -1 && value) {
			joinedQueries += (joinedQueries.length === 0 ? '' : '&') + parameter + '=' + value;
		}

		return window.location.href.split('?')[0] + '?' + joinedQueries;
	}

	if ($select.length > 0) {
		init();
	}
})(jQuery);
